export const authEndpoint = 'https://api.hey.car/uaa/oauth/token';
export const resetLead = (saleId: string): string => {
  return `https://api.common.prod.group-mobility-trader.com/sales/reset/${saleId}`;
};
export const duplicateInvoice = (invoice: string): string => {
  return `https://api-billing.de.prod.group-mobility-trader.com/billing/generate-invoice-from-canceled/${invoice}`;
};
export const easybillLink = (easybillDocumentId: string): string => {
  return `https://c119450.easybill.de/document-editor?documentID=${easybillDocumentId}`;
};
export const skipInvoicingImport = 'https://api.de.prod.group-mobility-trader.com/skip-invoicing/import';
export const settingsNetworkImport = 'https://api.de.prod.group-mobility-trader.com/settings/network/import';

export const sendInvoices = `https://api-billing.de.prod.group-mobility-trader.com/billing/send-and-complete`;
export const getInvoices = `https://api-billing.de.prod.group-mobility-trader.com/invoices/draft-filter`;
export const getLastBilling = `https://api-billing.de.prod.group-mobility-trader.com/billing-run/last-billing-dto`;
export const newBilling = `https://api-billing.de.prod.group-mobility-trader.com/billing-run/new-billing`;
